import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Add this import

import {
  GridContainer,
  MainDiv,
  LoadButton,
  BottomRightText,
  PageHeading,
} from "./Style";
import GridItems from "../GridItems/GridItems";
import EmailImg from "../../assets/mailing.png";
import ChatIcon from "../../assets/chat.png";
import SummaryIcon from "../../assets/summary.png";
import RecordIcon from "../../assets/record.png";
import SearchImg from "../../assets/search.png";
import PlanIcon from "../../assets/Plan.svg";
import ForestIcon from "../../assets/forest.png";
import TodoIcon from "../../assets/Todo.jpg";
import Navbar from "../Navbar/Navbar";

const HeroSection = () => {
  const navigate = useNavigate();
  const { isSidebarOpen, setIsSidebarOpen } = useOutletContext();
  const { t } = useTranslation(); // Add translation hook

  // Define grid items using translations
  const GridItemsObj = [
    {
      displayImg: TodoIcon,
      headerTitle: t("apps.todo.title"),
      description: t("apps.todo.description"),
      btnTxt: t("apps.todo.button"),
    },
    {
      displayImg: RecordIcon,
      headerTitle: t("sidebar.meetings"),
      description: t("apps.record.description"),
      btnTxt: t("apps.record.button"),
    },
    {
      displayImg: EmailImg,
      headerTitle: t("sidebar.emailAutomations"),
      description: t("apps.email.description"),
      btnTxt: t("apps.email.button"),
    },
    {
      displayImg: ChatIcon,
      headerTitle: t("sidebar.chatWithDoc"),
      description: t("apps.chat.description"),
      btnTxt: t("apps.chat.button"),
    },
    {
      displayImg: ForestIcon,
      headerTitle: t("apps.forest.title"),
      description: t("apps.forest.description"),
      btnTxt: t("apps.forest.button"),
    },
    {
      displayImg: SummaryIcon,
      headerTitle: t("sidebar.summarize"),
      description: t("apps.summary.description"),
      btnTxt: t("apps.summary.button"),
    },
    {
      displayImg: SearchImg,
      headerTitle: t("sidebar.generalSearch"),
      description: t("apps.search.description"),
      btnTxt: t("apps.search.button"),
      iframeSrc:
        "http://email-sorter-ssr-env.eba-jmuaduxk.eu-west-1.elasticbeanstalk.com/login/",
    },
  ];

  const handleButtonClick = (index) => {
    switch (index) {
      case 0:
        navigate("/todo");
        break;
      case 1:
        navigate("/transcriber");
        break;
      case 2:
        navigate("/email");
        break;
      case 3:
        navigate("/chat");
        break;
      case 4:
        navigate("/forest");
        break;
      case 5:
        navigate("/summarize");
        break;
      case 6:
        navigate("/generalsearch");
        break;
      default:
        break;
    }
  };

  return (
    <>
      <MainDiv isOpen={isSidebarOpen}>
        <Navbar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <PageHeading>{t("heroSection.pageHeading")}</PageHeading>
        <GridContainer
          isOpen={isSidebarOpen}
          style={{ marginBottom: "3rem", minHeight: "90vh" }}
        >
          {GridItemsObj.map((item, index) => (
            <GridItems
              key={index}
              index={index}
              displayImg={item.displayImg}
              headerTitle={item.headerTitle}
              description={item.description}
              btnTxt={item.btnTxt}
              onButtonClick={() => handleButtonClick(index)}
            />
          ))}
        </GridContainer>
        <BottomRightText>{t("heroSection.bottomText")}</BottomRightText>
      </MainDiv>
    </>
  );
};

export default HeroSection;
